<template>
  <div class="main-menu">
    <div class="menu-root">
      <a>
        <i class="far fa-folder"></i>Project
      </a>
      <a>
        <i class="far fa-comment-lines"></i>Messaging
      </a>
      <a>
        <i class="far fa-file-alt"></i>Form
      </a>
      <a>
        <i class="far fa-file-chart-line"></i>Reports
      </a>
      <a>
        <i class="far fa-filter"></i>Interpreters
      </a>
      <a>
        <i class="far fa-user-shield"></i>Admin
      </a>
      <a>
        <i class="far fa-user-cog"></i>Profile
      </a>
    </div>

    <div class="menu-options scrollable">
      <section>
        <div class="separator">Projects</div>
        <router-link class="menu-item" :to="{ name: 'mainTracking' }">
          <i class="far fa-folders"></i>Projects
        </router-link>
        <router-link class="menu-item" :to="{ name: 'main' }">
          <i class="far fa-grip-horizontal"></i>Catalogs
        </router-link>
        <router-link class="menu-item" :to="{ name: 'main' }">
          <i class="far fa-project-diagram"></i>Datamodels
        </router-link>
      </section>

      <section>
        <div class="separator">Messaging</div>
        <router-link class="menu-item" :to="{ name: 'main' }">
          <i class="far fa-envelope"></i>Messages
        </router-link>
        <router-link class="menu-item" :to="{ name: 'main' }">
          <i class="far fa-edit"></i>Compose message
        </router-link>
        <router-link class="menu-item" :to="{ name: 'main' }">
          <i class="far fa-paper-plane"></i>Send message
        </router-link>
        <router-link class="menu-item" :to="{ name: 'main' }">
          <i class="far fa-tag"></i>Tagged Queries
        </router-link>
        <router-link class="menu-item" :to="{ name: 'main' }">
          <i class="far fa-clipboard-check"></i>Rules
        </router-link>
        <router-link class="menu-item" :to="{ name: 'main' }">
          <i class="far fa-server"></i>Gateways
        </router-link>
        <router-link class="menu-item" :to="{ name: 'main' }">
          <i class="far fa-comments"></i>Chat
        </router-link>
      </section>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class MainMenu extends Vue {}
</script>

<style lang="scss" scopped>
.main-menu {
  height: 100%;
  padding: 17px 8px;
  a {
    display: block;
    text-decoration: none;
    color: #4b4b4b;
    padding: 12px 15px;
    font-weight: 300;
    font-size: 0.98rem;
    border-bottom: 1px solid #e7e7e7;
    cursor: pointer;
    i {
      float: right;
      opacity: 0.3;
      font-size: 1.25rem;
      display: none;
    }
    &:hover {
      text-decoration: none;
      color: inherit;
      background-color: var(--element-hover-bg-color);
      i {
        opacity: 0.5;
      }
    }
    &.active {
      background-color: #ececec;
    }
  }
}

.menu-root {
  max-width: 125px;
}
.menu-options {
  position: absolute;
  top: 10px;
  left: 140px;
  right: 10px;
  bottom: 10px;
  background-color: #ececec;
  border-radius: 4px;
  padding: 10px;
  overflow-y: auto;
  .separator {
    padding: 10px 14px;
    border-bottom: 1px solid #ccc;
  }
  a {
    font-size: 0.85rem;
    i {
      display: block;
    }
  }
}
</style>
